import type { ButterflyMedia } from '$lib/types';
type MediaSourcesHandler = (
  media: ButterflyMedia | null,
  srcset: { media: string; width: number }[],
  format?: 'thumb' | 'source' | 'default' | 'square' | 'cover' | 'stories',
) => { media: string; srcset: string; type: string }[];

import forEach from 'lodash/forEach';
import getMediaUrl from '$lib/getMediaUrl';

const getMediaSources: MediaSourcesHandler = (media, srcset, format = 'thumb') => {
  const res: { media: string; srcset: string; type: string }[] = [];
  if (!media) {
    return res;
  }

  forEach(srcset, (ss) => {
    res.push({
      media: ss.media,
      type: 'image/jpeg',
      srcset: getMediaUrl(media, { format, ext: 'jpg', width: ss.width }) + ' 1x',
    });
    res.push({
      media: ss.media,
      type: 'image/webp',
      srcset: getMediaUrl(media, { format, ext: 'webp', width: ss.width }) + ' 1x',
    });
    res.push({
      media: ss.media,
      type: 'image/jpeg',
      srcset: getMediaUrl(media, { format, ext: 'jpg', width: ss.width * 2 }) + ' 2x',
    });
    res.push({
      media: ss.media,
      type: 'image/webp',
      srcset: getMediaUrl(media, { format, ext: 'webp', width: ss.width * 2 }) + ' 2x',
    });
  });
  return res;
};

export default getMediaSources;
